import React, { Component } from 'react';
import { FormattedMessage } from 'react-intl';
import Tabs from "../tabs.component";

class MyAccountTabs extends Component {

    constructor(props, context) {
        super(props, context)
    }


    render() {
        return (
            <Tabs value={[
                {
                    name: <FormattedMessage
                        id="menu.tabs.my_account.settings"
                        defaultMessage="Settings"
                    />,
                    link: '/settings',
                },
                {
                    name: <FormattedMessage
                        id="menu.tabs.my_account.users"
                        defaultMessage="Users"
                    />,
                    link: '/users/listing',
                },
                {
                    name: <FormattedMessage
                        id="menu.tabs.my_account.roles"
                        defaultMessage="Roles"
                    />,
                    link: '/roles/listing',
                },
                {
                    name: <FormattedMessage
                        id="menu.tabs.my_account.locations"
                        defaultMessage="Locations"
                    />,
                    link: '/locations/listing',
                },
                {
                    name: <FormattedMessage
                        id="menu.tabs.my_account.fees"
                        defaultMessage="Fees"
                    />,
                    link: '/settings/fees/listing?feeType=fee',
                },
                {
                    name: <FormattedMessage
                        id="menu.tabs.my_account.taxes"
                        defaultMessage="Taxes"
                    />,
                    link: '/settings/taxes/listing',
                },
                {
                    name: <FormattedMessage
                        id="menu.tabs.my_account.payment_terms"
                        defaultMessage="Payment terms"
                    />,
                    link: '/payment-terms/listing',
                },
                {
                    name: <FormattedMessage
                        id="menu.tabs.my_account.payment_types"
                        defaultMessage="Payment types"
                    />,
                    link: '/payment-types/listing',
                    restrictedIntegrations: ['shopify-expert-app'],
                },
                {
                    name: <FormattedMessage
                        id="menu.tabs.my_account.order_statuses"
                        defaultMessage="Order statuses"
                    />,
                    link: '/order-statuses/listing',
                    restrictedIntegrations: ['shopify', 'shopify-expert-app'],
                },
                {
                    name: <FormattedMessage
                        id="menu.tabs.my_account.integrations"
                        defaultMessage="Integrations"
                    />,
                    link: '/integrations/listing',
                },
                {
                    name: <FormattedMessage
                        id="menu.tabs.my_account.subscription"
                        defaultMessage="Subscription"
                    />,
                    link: '/my-account',
                },
            ]} />
        );
    }
}

export default MyAccountTabs


// WEBPACK FOOTER //
// ./src/common/layout/tabs/myaccount.component.jsx